export const customStyles = {
    multiValue: (styles) => {
        return {
            ...styles,
            color: "#2672bd",
            backgroundColor: "white",
            border: "1px solid #2672BB",
            borderRadius: "6px",
        };
    },
    multiValueLabel: (styles) => ({
        ...styles,
        color: "#2672bd",
    }),
    control: (base) => ({
        ...base,
        backgroundColor: "#f2f5f7",
    }),
    placeholder: (base) => ({
        ...base,
        // because React Select uses an actual element instead of a placeholder attribute we set
        // an accessible colour here
        color: "#585858",
    }),
};
